import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AnalyticsLoaderService } from './analytics-loader-service';
import { AnalyticsTrackingService } from './analytics-tracking-service';

@Injectable({ providedIn: 'root' })
export class AnalyticsInitializerService {
  private loadPromise: Promise<void> | undefined;

  constructor(
    private analytics: AnalyticsTrackingService,
    private loader: AnalyticsLoaderService,
    private router: Router,
  ) {}

  load(ga4MeasurementId: string): Promise<void> {
    this.loadPromise ??= this.loader
      .load(ga4MeasurementId)
      .then(() => {
        this.router.events
          .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
          .subscribe((e) => {
            this.analytics.pageView(e.urlAfterRedirects);
          });
      })
      .catch(() => {
        console.warn('Google Analytics could not be initialized.');
      });
    return this.loadPromise;
  }
}
